/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import AuthContainer from './AuthContainer.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import MultiFactorCodeControl from 'shared/ui/components/form-components/MultiFactorCodeControl.vue';

// Mixins
import errorHandler from 'auth/mixins/errorHandler';

const __vue_script__ = {
    name: 'NewPasswordMFA',

    components: { AuthContainer, Checkbox, MultiFactorCodeControl },

    mixins: [errorHandler],

    data() {
        return {
            errors: [],
            locked: false,
            mfaToken: '',
            phoneDigits: '',
            resending: false,
            rememberMe: false,
            validationCode: '',
            verifying: false
        };
    },

    created() {
        this.mfaToken = this.$route.query.mfa_token;
        this.phoneDigits = this.$route.query.phone_digits;
    },

    methods: {
        async resend() {
            try {
                if (this.resending) {
                    return;
                }
                this.resending = true;

                const { data } = await this.$services.account.resetPasswordWithMfa(
                    this.mfaToken,
                    undefined,
                    true,
                );
                this.mfaToken = data.mfa_token;
                this.validationCode = '';
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('login.messages.code_resent').toString(),
                    type: 'success',
                    duration: 5000
                });
            } catch {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('login.messages.code_resent_error').toString(),
                    type: 'error',
                    duration: 5000
                });
            } finally {
                setTimeout(() => { this.resending = false; }, 15000);
            }
        },

        async verify() {
            this.errors = [];
            this.verifying = true;

            try {
                const { data } = await this.$services.account.resetPasswordWithMfa(
                    this.mfaToken,
                    this.validationCode,
                );

                if (data.ok) {
                    console.info('[NewPassword] Password successfully resetted');

                    this.$notify({
                        group: 'flashes',
                        text: this.$i18n.t('login.messages.password_resetted').toString(),
                        type: 'success',
                        duration: 5000
                    });

                    this.$router.push(this.$const.ROUTE_LOGIN);
                } else if (data.account_locked) {
                    this.locked = true;
                } else {
                    this.verifying = false;
                    this.validationCode = '';
                    this.errors = [this.$t('login.errors.invalid_code')];
                }
            } catch (error) {
                this.handleError(error);
            } finally {
                this.verifying = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-container',{attrs:{"back-to-login-in-header":true}},[_c('div',{staticClass:"new-password-mfa mfa-validation"},[_c('validation-observer',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"mfa-prompt",attrs:{"aria-label":_vm.$t('login.forms.mfa.code')},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.verify)}}},[(_vm.locked)?_c('div',{staticClass:"alert alert-error"},[_c('p',[_vm._v(_vm._s(_vm.$t('login.errors.account_locked')))]),_c('router-link',{staticClass:"reset-link",attrs:{"to":_vm.$const.ROUTE_SEND_RESET_TOKEN}},[_vm._v(_vm._s(_vm.$t('login.links.reset_password'))+".")])],1):_vm._e(),_c('div',{staticClass:"text-prompt"},[_c('i18n',{attrs:{"path":"login.forms.mfa.enter_code"}},[_c('strong',[_vm._v(_vm._s(("*" + _vm.phoneDigits)))])])],1),_c('multi-factor-code-control',{attrs:{"errors":_vm.errors,"name":"code"},model:{value:(_vm.validationCode),callback:function ($$v) {_vm.validationCode=$$v},expression:"validationCode"}}),_c('button',{staticClass:"btn btn-login",attrs:{"disabled":_vm.verifying}},[_vm._v(_vm._s(_vm.$t('login.forms.submit' )))]),_c('a',{staticClass:"resend",attrs:{"href":"#","disabled":_vm.resending},on:{"click":function($event){$event.preventDefault();return _vm.resend.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('login.links.resend_code')))])],1)]}}])})],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "NewPasswordMFA.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__